/**
 * Maps internal worker names to the small vocabulary users understand.
 *
 * Job identifiers remain stable backend contracts; presentation labels belong
 * here so scheduler and history screens do not duplicate or expose execution
 * implementation names.
 */
const JOB_TYPE_LABELS: Record<string, string> = {
  monitor_bills: 'Monitor',
  pipeline_execution: 'Pipeline',
  process_bills: 'Process',
  sync_bills: 'Sync',
}

export function formatJobType(processName: string): string {
  const configured = JOB_TYPE_LABELS[processName]
  if (configured) return configured

  return processName
    .split(/[_-]+/)
    .filter(Boolean)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}
